import { Tabs, TabsList, TabsTrigger, TabsContent } from '@/components/ui/tabs';
import { FigureLayoutTab } from './tabs/FigureLayoutTab';
import { FigureSharedTab } from './tabs/FigureSharedTab';
import { FigureStyleTab } from './tabs/FigureStyleTab';
import { useFigureCompositionStore } from '@/store/figure-composition';

interface FigurePropertiesProps {
  showAdvanced: boolean;
}

export function FigureProperties({ showAdvanced }: FigurePropertiesProps) {
  const currentComposition = useFigureCompositionStore((state) => state.currentComposition);

  if (!currentComposition) return null;

  return (
    <div className="h-full flex flex-col">
      <Tabs defaultValue="layout" className="flex-1 flex flex-col h-full">
        {/* Horizontal tabs on top */}
        <div className="border-b border-border bg-muted/30">
          <div className="overflow-x-auto">
            <TabsList className="flex h-9 min-w-max gap-1 bg-transparent px-3 pt-2 pb-1">
              <TabsTrigger 
                value="layout" 
                className="h-8 rounded-full px-3 text-xs font-medium data-[state=active]:bg-background data-[state=active]:shadow-sm data-[state=active]:text-foreground data-[state=active]:font-semibold data-[state=inactive]:text-muted-foreground hover:bg-muted"
              >
                Layout
              </TabsTrigger>
              <TabsTrigger 
                value="shared" 
                className="h-8 rounded-full px-3 text-xs font-medium data-[state=active]:bg-background data-[state=active]:shadow-sm data-[state=active]:text-foreground data-[state=active]:font-semibold data-[state=inactive]:text-muted-foreground hover:bg-muted"
              >
                Shared
              </TabsTrigger>
              <TabsTrigger 
                value="style" 
                className="h-8 rounded-full px-3 text-xs font-medium data-[state=active]:bg-background data-[state=active]:shadow-sm data-[state=active]:text-foreground data-[state=active]:font-semibold data-[state=inactive]:text-muted-foreground hover:bg-muted"
              >
                Style
              </TabsTrigger>
            </TabsList>
          </div>
        </div>

        {/* Content area below tabs */}
        <div className="flex-1 overflow-hidden">
          <div className="h-full overflow-y-auto px-3 py-3">
            <TabsContent value="layout" className="mt-0">
              <FigureLayoutTab />
            </TabsContent>
            <TabsContent value="shared" className="mt-0">
              <FigureSharedTab />
            </TabsContent>
            <TabsContent value="style" className="mt-0">
              <FigureStyleTab />
            </TabsContent>
          </div>
        </div>
      </Tabs>
    </div>
  );
}
